import React, { Component, useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import {
  selectZoomCourseType,
  updateZoomCourseEventsIds
} from '../../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import GetAppIcon from '@material-ui/icons/GetApp'
import Box from '@material-ui/core/Box'

import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import BrowserStore from 'store'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'

import { getZoomQueueCourses } from '../../../services/saga'
import Chip from '@material-ui/core/Chip'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import ReplayIcon from '@material-ui/icons/Replay'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  }
}))

function StepOneQueue(props) {
  const classes = useStyles()
  const { data, onTabChange, onCourseIdChanges } = props
  const userData = BrowserStore.get('inseadCanvasAdmin')
  const [value, setValue] = React.useState(0)
  const [radioValue, setRadioValue] = React.useState('30')
  const [courseIdsData, setCourseIdsData] = React.useState([])
  const [newCourseIds, setNewCourseIds] = React.useState([])
  const [inputText, setInputText] = React.useState('')
  const [loadingGetCoursesJson, setLoadingGetCoursesJson] =
    React.useState(false)
  const [deleteCourseIDs, setDeleteCourseIDs] = React.useState([])

  const [inputError, setInputError] = React.useState(false)
  const [inputErrorTxt, setInputErrorTxt] = React.useState(false)

  let zoom_update_courses_delete = false

  if (userData.sub_account.hasOwnProperty('feature_permissions')) {
    if (
      userData.sub_account['feature_permissions'].hasOwnProperty(
        'zoom_update_courses_delete'
      )
    ) {
      zoom_update_courses_delete = true
    }
  }

  const isNumber = (value) => {
    return /[^0-9]/g.test(value)
  }

  const handleChange = (evt) => {
    setInputText(evt.target.value)
  }

  const handleKeyDown = (evt) => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault()

      var value = inputText.trim()

      console.log(isNumber(value))

      if (isNumber(value)) {
        setInputError(true)
        setInputErrorTxt('Only numeric values are allowed.')
      }

      if (isNumber(value) === false) {
        setInputError(false)
        setInputErrorTxt()

        let newIds = [...newCourseIds, value]

        setNewCourseIds([...newIds])

        let dataSet = {
          courseId: '',
          courseIds: [...newIds, ...courseIdsData],
          requestedBy: userData.sub_account.email,
          daysCount: 30
        }

        onCourseIdChanges(dataSet)

        setInputText('')
      }
    }
  }

  const handleDelete = (chipToDelete) => () => {
    let newDeleteIds = [...deleteCourseIDs, chipToDelete]
    setDeleteCourseIDs([...newDeleteIds])
    setCourseIdsData((chips) => chips.filter((chip) => chip !== chipToDelete))
  }

  const handleDeleteNew = (chipToDelete) => () => {
    setNewCourseIds((chips) => chips.filter((chip) => chip !== chipToDelete))
  }

  const rollbackDeletedCourseIDs = (chipToAdd) => () => {
    let newIds = [chipToAdd, ...courseIdsData]
    setDeleteCourseIDs((chips) => chips.filter((chip) => chip !== chipToAdd))
    setCourseIdsData([...newIds])
  }

  useEffect(() => {
    let dataSet = {
      courseId: '',
      courseIds: [...newCourseIds, ...courseIdsData],
      requestedBy: userData.sub_account.email,
      daysCount: radioValue
    }

    onCourseIdChanges(dataSet)
  }, [courseIdsData, newCourseIds])

  const [advice, setAdvice] = useState('')

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingGetCoursesJson(true)
        const response = await getZoomQueueCourses()

        let data = JSON.parse(response.data)

        setCourseIdsData(
          data.courseIds.sort(function (a, b) {
            return a - b
          })
        )
        setLoadingGetCoursesJson(false)

        // setAdvice(json.slip.advice);
      } catch (error) {
        console.log('error', error)
      }
    }

    fetchData()
  }, [data.isSingleCourse])

  useEffect(() => {
    if (courseIdsData.length !== 0) {
    }
  }, [courseIdsData])

  return (
    <div>
      <FormControl fullWidth autoComplete='off'>
        <TextField
          error={inputError}
          id='standard-adornment-amount'
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          value={inputText}
          label='Type Course ID and Press Enter to add courses'
          helperText={inputErrorTxt}
        />
      </FormControl>

      <p></p>

      {loadingGetCoursesJson === true ? <LinearProgress /> : null}

      <Paper component='ul' className={classes.root}>
        {deleteCourseIDs.map((data, i) => {
          return (
            <li key={i}>
              <Chip
                label={data}
                onDelete={rollbackDeletedCourseIDs(data)}
                className={classes.chip}
                style={{ color: 'red', backgroundColor: '#fff0f0' }}
                variant='outlined'
                deleteIcon={<ReplayIcon />}
              />
            </li>
          )
        })}

        {courseIdsData.map((data, i) => {
          return (
            <li key={i}>
              <Chip
                label={data}
                onDelete={
                  zoom_update_courses_delete == true ? handleDelete(data) : null
                }
                className={classes.chip}
              />
            </li>
          )
        })}

        {newCourseIds.map((data, i) => {
          return (
            <li key={i}>
              <Chip
                label={data}
                onDelete={handleDeleteNew(data)}
                className={classes.chip}
                color='primary'
                variant='outlined'
              />
            </li>
          )
        })}
      </Paper>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    data: state.Zoom
  }
}

const mapDispatchToProps = (dispatch) => ({
  onTabChange: (type) => {
    dispatch(selectZoomCourseType(type))
  },

  onCourseIdChanges: (ids) => {
    dispatch(updateZoomCourseEventsIds(ids))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StepOneQueue)
